import { positions, Provider as AlertProvider } from "react-alert";
import { QueryClientProvider } from "react-query";
import ReactDOM from "react-dom";
import React from "react";

import AlertSnack from "./components/alert-snack/AlertSnack";
// import { PushButtonProvider } from "./contexts/PushButtonContext";
// import { SensorProvider } from "./contexts/SensorContext";
import { MainProvider } from "./contexts/MainContext";
import { queryClient } from "./services/reactQuery";
import "./services/axios";
import App from "./App";
import "./index.css";

const AlertOptions = {
  timeout: 2500,
  position: positions.BOTTOM_LEFT,
  containerStyle: {
    zIndex: 222222222,
  },
};

ReactDOM.render(
  <React.Fragment>
    <QueryClientProvider client={queryClient}>
      <AlertProvider template={AlertSnack} {...AlertOptions}>
        {/* <PushButtonProvider> */}
        {/* <SensorProvider> */}
        <MainProvider>
          <App />
        </MainProvider>
        {/* </SensorProvider> */}
        {/* </PushButtonProvider> */}
      </AlertProvider>
    </QueryClientProvider>
  </React.Fragment>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
